<template lang="pug">
.container.grid-lg.my-2.py-2
  fieldset(:disabled="loading")
    form
      .panel
        .panel-header
          .h5 Novos serviços em massa
          small Serão criados <code>n</code> serviços de acordo com o campo <code>quantidade</code> para cada fiscal selecionado
        .panel-body.columns
          form-group.column.col-12(
            label="Quantidade",
            :validation="$v.form.quantidade"
          )
            input.form-input(
              type="number",
              v-model="$v.form.quantidade.$model"
            )
          form-group.column.col-12(
            :label="'ordem_servico.assunto' | tModel",
            :validation="$v.form.ordem_servico.assunto_id"
          )
            assunto-picker(
              v-model="$v.form.ordem_servico.assunto_id.$model",
              @selected="onSelectedAssunto"
            )
          form-group.column.col-12(
            label="Grupo de usuários",
            :validation="$v.form.grupo_usuarios_id"
          )
            usuario-grupo-picker(v-model="$v.form.grupo_usuarios_id.$model")
            grupo-usuarios.mt-2(
              v-if="$v.form.grupo_usuarios_id.$model",
              :usuario_grupo_id="$v.form.grupo_usuarios_id.$model",
              v-model="$v.form.usuario_responsavel_ids.$model"
            )
          form-group.column.col-12(
            :label="'ordem_servico.analista' | tModel",
            :validation="$v.form.ordem_servico.analista_id",
            v-if="assunto && assunto.permite_analise"
          )
            fiscal-picker(v-model="$v.form.ordem_servico.analista_id.$model")
          .column.col-12.divider.text-center(data-content="Protocolo")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_tipo' | tModel",
            :validation="$v.form.ordem_servico.protocolo_tipo"
          )
            select-protocolo-tipo(
              v-model="$v.form.ordem_servico.protocolo_tipo.$model"
            )
          form-group.column.col-3.col-sm-12(
            v-if="form.ordem_servico.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.ordem_servico.protocolo_numero"
          )
            the-mask.form-input(
              v-model="$v.form.ordem_servico.protocolo_numero.$model",
              type="tel",
              mask="##.##.########/####.##",
              :masked="true"
            )
          form-group.column.col-3.col-sm-12(
            v-else,
            :label="'ordem_servico.protocolo_numero' | tModel",
            :validation="$v.form.ordem_servico.protocolo_numero"
          )
            input.form-input(
              v-model="$v.form.ordem_servico.protocolo_numero.$model"
            )
          form-group.column.col-3.col-sm-12(
            :disabled="form.ordem_servico.protocolo_tipo === 'sei'",
            :label="'ordem_servico.protocolo_ano' | tModel",
            :validation="$v.form.ordem_servico.protocolo_ano"
          )
            year.form-input(
              v-model="$v.form.ordem_servico.protocolo_ano.$model"
            )
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.protocolo_data' | tModel",
            :validation="$v.form.ordem_servico.protocolo_data"
          )
            datepicker(v-model="$v.form.ordem_servico.protocolo_data.$model")
          form-group.column.col-3.col-sm-12(
            :label="'ordem_servico.prazo' | tModel",
            :validation="$v.form.ordem_servico.prazo"
          )
            int.form-input(v-model="$v.form.ordem_servico.prazo.$model")
          form-group.column.col-12(:validation="$v.form.ordem_servico.agendar")
            label.form-switch
              input(
                type="checkbox",
                v-model="$v.form.ordem_servico.agendar.$model"
              )
              i.form-icon
              | É necessário agendar
          .column.col-12.divider.text-center
          form-group.column.col-12(
            :label="'ordem_servico_info.obs' | tModel",
            :validation="$v.form.ordem_servico.info.obs"
          )
            textarea.form-input(
              v-model="$v.form.ordem_servico.info.obs.$model",
              rows="3"
            )
        .panel-footer.text-right
          button.btn.btn-primary(
            type="button",
            :disabled="$v.$invalid",
            :class="loading",
            @click="save"
          ) Salvar
</template>

<script>
import { deepKey } from "paliari-js-utils"
import { required, maxLength } from "vuelidate/lib/validators"
import toastErrors from "@/lib/errors/toastErrors"
import GrupoUsuarios from "./GrupoUsuarios"

export default {
  components: { GrupoUsuarios },
  vuex: {
    servicos: {
      getters: ["loading"],
      actions: ["fetchCreateMassa"],
    },
  },
  computed: {
    grupoUsuariosId() {
      return this.form.grupo_usuarios_id
    },
  },
  methods: {
    async save() {
      try {
        await this.fetchCreateMassa(this.form)
        this.$toaster.success("Serviços criados com sucesso")
        this.$router.replace({ name: "app.osm.servicos" })
      } catch (e) {
        toastErrors(e)
      }
    },
    onSelectedAssunto(assunto) {
      this.$set(this, "assunto", assunto)
      this.$set(
        this.form.ordem_servico,
        "prazo",
        deepKey(assunto, "prazo") || 0,
      )
    },
  },

  data() {
    return {
      form: {
        quantidade: null,
        grupo_usuarios_id: null,
        usuario_responsavel_ids: [],
        ordem_servico: {
          assunto_id: null,
          protocolo_tipo: "geral",
          protocolo_numero: null,
          protocolo_ano: 0,
          protocolo_data: "",
          analista_id: null,
          agendar: false,
          info: { obs: "" },
          prazo: 0,
        },
      },
      assunto: null,
    }
  },

  validations() {
    const validations = {
      form: {
        quantidade: { required },
        grupo_usuarios_id: { required },
        usuario_responsavel_ids: { required },
        ordem_servico: {
          assunto_id: { required },
          protocolo_tipo: {},
          protocolo_numero: {},
          analista_id: {},
          agendar: {},
          protocolo_ano: {},
          protocolo_data: {},
          info: { obs: { required, maxLength: maxLength(4000) } },
          prazo: {},
        },
      },
    }
    if (this.assunto && this.assunto.exige_analise) {
      validations.form.ordem_servico.analista_id = { required }
    }

    return validations
  },

  watch: {
    grupoUsuariosId() {
      this.form.usuario_responsavel_ids = []
    },
  },
}
</script>
